import * as React from "react";
import { NavigateOptions, useLocation, useNavigate } from "react-router-dom";
import { useNavigationStore } from "../stores/navigationStore";

export type NavigationOptions = NavigateOptions & {
  searchParams?: Record<string, unknown>;
  data?: unknown;
};

function encodeQuery(params: Record<string, unknown>) {
  return `?${Object.entries(params)
    .map(([k, v]) => `${k}=${v}`)
    .join("&")}`;
}

export default function useNavigation() {
  const rrNavigate = useNavigate();
  const location = useLocation();
  const { setData, dataByPath, routes } = useNavigationStore();

  const data = dataByPath[location.pathname];

  const navigate = React.useCallback(
    (path: string, options?: NavigationOptions) => {
      const { data, searchParams, ...rrOptions } = options ?? {};
      if (data !== undefined) setData(path, data);
      const qs = searchParams ? encodeQuery(searchParams) : "";
      rrNavigate(`${path}${qs}`, rrOptions);
    },
    [rrNavigate, setData],
  );

  const goBack = React.useCallback(() => rrNavigate(-1), [rrNavigate]);

  return {
    navigate,
    goBack,
    data,
    dataByPath,
    routes: routes.map((route) => ({
      ...route,
      data: dataByPath[route.path],
    })),
  };
}
